var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"item"},[_c('div',{staticClass:"item-title"},[_c('div',[_vm._v(_vm._s(_vm.id ? '订单编号：' + _vm.id : '服务费'))]),_vm._v(" "),_c('div',{staticClass:"time"},[_vm._v(_vm._s(_vm.time))])]),_vm._v(" "),_c('span',{staticClass:"item-value"},[_vm._v(_vm._s(_vm.price))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-222b4518","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/order_item.vue
// module id = null
// module chunks = 